var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M2 7.43v6c0 1.5.5 2.75 1.38 3.63.87.87 2.12 1.37 3.62 1.37v2.13c0 .8.89 1.28 1.55.84L13 18.43h2.12q-.12-.45-.12-.93c0-1.02.39-1.96 1.03-2.67.72-.82 1.79-1.33 2.97-1.33 1.12 0 2.14.46 2.87 1.21.09-.4.13-.83.13-1.28v-6c0-3-2-5-5-5H7c-3 0-5 2-5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15 17.5q0 .48.12.93c.09.4.25.79.46 1.13A3.97 3.97 0 0 0 19 21.5c1.03 0 1.96-.39 2.66-1.03.3-.26.56-.57.76-.91.37-.6.58-1.31.58-2.06a3.995 3.995 0 0 0-4-4c-1.18 0-2.25.51-2.97 1.33-.64.71-1.03 1.65-1.03 2.67m2.51-.02h2.98M19 16.02v2.99"
  })));
};
export default SvgComments;